import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../integration.service';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NotifierService } from "angular-notifier";
import axios from 'axios'

declare var Chargebee;

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})

export class AccountSettingsComponent implements OnInit {
  private readonly notifier: NotifierService;
  alertTypes
  private userId;
  public username;
  public phone;
  public email;
  closeResult: string;
  subscriptionPlan;
  cbInstance;
  loading;

  constructor(notifierService: NotifierService,private _integrationService:IntegrationService,private http:HttpClient,private modalService:NgbModal,private router:Router) {
    this._integrationService.userId$.subscribe((data)=>{this.userId=data});
    this._integrationService.userName$.subscribe((data)=>{this.username=`${data[0].toUpperCase()}${data.slice(1,)}`.replace('My','')});
    this._integrationService.phone$.subscribe((data)=>{this.phone=data})
    this._integrationService.email$.subscribe((data)=>this.email=data)
    this._integrationService.alertTypes.subscribe((data)=>this.alertTypes=data)
    this._integrationService.subscriptionPlan$.subscribe((data)=>{this.subscriptionPlan=data})
    this.notifier = notifierService;
    this.cbInstance = Chargebee.init({
      site: "subscrybe"
    })
  }

  ngOnInit() {
    let upgradedNotif = localStorage.getItem('upgradedNotif')
    if(upgradedNotif == 'true'){
      this.notifier.notify('success','You have successfully upgraded to premium :), and have now been granted access to premium features!')
      localStorage.setItem('upgradedNotif','false')
    }
  }

  addType(value){
    if(value){
      this.alertTypes.push(value);
    } 
  }

  updateName(event){
    this.username = event.target.value;
  }

  updateEmail(event){
    this.email = event.target.value;
  }

  updatePhone(event){
    this.phone = event.target.value;
  }

  updateAccount(){
    let endpoint = `https://subscrybe-backend.herokuapp.com/update-user/${this.userId.replace(/"/g,"")}`
    let reqBody = {
      username:this.username,
      phone:this.phone,
      email:this.email,
      alertTypes:this.alertTypes
    }
    this.http.patch(endpoint,reqBody).subscribe(
      data=>{
        this.notifier.notify('success','Account setting updated!')
        let refreshToken = localStorage.getItem('refreshToken')
        let refreshEndpoint  = 'https://subscrybe-backend.herokuapp.com/refresh'
        var refreshHeader = {
          headers: new HttpHeaders()
            .set('Authorization',  `Bearer ${refreshToken}==`)
        }
        this.http.post(refreshEndpoint,{},refreshHeader).subscribe(
          data=>{
            let newToken = data['access_token']
            console.log(data)
            localStorage.setItem('token',newToken)
            this._integrationService.getUser();
          }
        )
      }, error =>{
        this.notifier.notify('error','Could not update account settings')
      }
    )
  }

  getOptions(alertTypes){
    let res = []
    if(!alertTypes.includes('email')){
      res.push('email')
    }

    if(!alertTypes.includes('text')){
      res.push('text')
    }

    return res;
  }

  urlEncode = function(data) {
    var str = [];
    for (var p in data) {
        if (data.hasOwnProperty(p) && (!(data[p] == undefined || data[p] == null))) {
            str.push(encodeURIComponent(p) + "=" + (data[p] ? encodeURIComponent(data[p]) : ""));
        }
    }
    return str.join("&");
  }

  formattedPlan(){
    let plan = this.subscriptionPlan.split('-')[(this.subscriptionPlan.split('-').length) -1]
    return `${plan[0].toUpperCase()}${plan.slice(1,)}`
  }

  handleCheckout(event){
    console.log(event)
    let reqData = {
      planId:'subscrybe-premium',
      subscriberId:this.userId.replace(/"/g,""),
      email:this.email,
      name:this.username,
      phone:this.phone
    }
    this.loading = true;
    let endpoint = 'https://subscrybe-backend.herokuapp.com/subscriptions/generate_checkout_new_url'
    // this.http.post(endpoint,reqData).subscribe(data=>{
    //   window.open(data['url'])
    // })
    this.cbInstance.openCheckout({
      hostedPage:() =>{
        var data = reqData;
        return axios.post(endpoint,reqData).then((response) => response.data)
      },
      success(hostedPageId){
        console.log(hostedPageId);
      },
      close:() =>{
        this.loading = false;
        this.notifier.notify("success", "Congratulations! You are now a premium subscribe user");
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/settings']);
        }); 
      },
      step(step){
        if(step == 'thankyou_screen'){
          // this._integrationService.getUser();
          localStorage.setItem('upgradedNotif','true')
          window.location.reload();
        }
      }
    })
    event.preventDefault();
  }

  // handleOpen(event){
  //   var cbInstance = Chargebee.getInstance();
  //   let endpoint = 'http://localhost:5000/subscriptions/generate_portal'
  //   var chargebeePortalInstance = cbInstance.createChargebeePortal()
  //   cbInstance.setPortalSession(function(){
  //     return axios.post(endpoint,{}).then((response) => response.data)
  //   })
  //   chargebeePortalInstance.open({

  //   })
  // }
  handleOpen(event){
    this.notifier.notify('success','hey bitch!')
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  open(content){
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  cancel(content){
    let endpoint = 'https://subscrybe-backend.herokuapp.com/subscriptions/cancel_premium'
    let body = {
      userId:this.userId,
      email:this.email
    }
    this.http.post(endpoint,body).subscribe(data=>{
      this.notifier.notify('success','Subscrybe Subscription Updated')
      this.modalService.dismissAll('');
    })
  }

  keep(content){
    this.modalService.dismissAll('')
  }
}
